<template>
  <v-dialog
    persistent
    :value="true"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card :class="{ 'wrapper-content': $vuetify.breakpoint.mdAndUp }">
      <v-card class="mb-5" elevation="0">
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <h2>SALVAR ALTERAÇÕES</h2>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
            class="d-flex justify-sm-start justify-md-end"
          >
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <v-btn outlined class="mr-3" @click="$emit('close')"
                >Voltar</v-btn
              >
              <v-btn
                class="gradient-primary"
                @click="$emit('save')"
                :disabled="isLoadingEdition"
              >
                Salvar
                <v-progress-circular
                  indeterminate
                  v-if="isLoadingEdition"
                  size="18"
                  class="ml-5"
                />
              </v-btn>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="8">
                  <div>
                    <p class="warning-message">
                      <span>
                        <v-icon color="#fa5e15">
                          mdi-alert-circle
                        </v-icon>
                      </span>
                      <span>
                        A versão atual do INEWS será substituída pela versão
                        editada por você.
                      </span>
                    </p>
                  </div>
                </v-col>
                <v-col cols="4" class="d-flex justify-end">
                  <v-btn
                    class="btn-actions-mobile mr-2"
                    x-small
                    elevation="0"
                    @click="$emit('close')"
                  >
                    <v-icon color="#ee8e51">
                      mdi-close
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="btn-actions-mobile gradient-primary"
                    x-small
                    elevation="0"
                    @click="$emit('save')"
                    :disabled="isLoadingEdition"
                  >
                    <v-progress-circular
                      indeterminate
                      v-if="isLoadingEdition"
                      size="18"
                    />
                    <v-icon color="#fff" v-else>
                      mdi-check
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-tabs v-model="tab">
                    <v-tab v-for="header in headerTabs" :key="header">
                      {{ header }}
                    </v-tab>
                  </v-tabs>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-col cols="6">
            <HeaderComponent currentVersion @open="openCurrentPanelFields">
              <ExpandedExtraFieldsComponent
                :fields="currentFormatted.extra_fields"
                :showExtraFields="currentPanelFields"
              />
            </HeaderComponent>

            <v-card v-if="loadingCurrentSlug">
              <v-skeleton-loader type="article"></v-skeleton-loader>
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-card>
            <SlugContentComponent v-else :slug="currentFormatted" />
          </v-col>
          <v-col cols="6">
            <HeaderComponent @open="openDraftPanelFields">
              <ExpandedExtraFieldsComponent
                :fields="draft.extra_fields"
                :showExtraFields="draftPanelFields"
              />
            </HeaderComponent>

            <SlugContentComponent :slug="draft" />
          </v-col>
        </template>
        <template v-else>
          <v-col cols="12">
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card v-if="loadingCurrentSlug">
                  <v-skeleton-loader type="article"></v-skeleton-loader>
                  <v-skeleton-loader type="article"></v-skeleton-loader>
                </v-card>
                <template v-else>
                  <InfoContentComponent
                    :modified_date="'2023-09-25T13:39:14.000Z'"
                    :modified_by="'bleitao'"
                  />
                  <SlugContentComponent
                    :slug="currentFormatted"
                    @open="openCurrentPanelFields"
                  >
                    <ExpandedExtraFieldsComponent
                      :fields="currentFormatted.extra_fields"
                      :showExtraFields="currentPanelFields"
                    />
                  </SlugContentComponent>
                </template>
              </v-tab-item>
              <v-tab-item>
                <SlugContentComponent
                  :slug="draft"
                  @open="openDraftPanelFields"
                >
                  <ExpandedExtraFieldsComponent
                    :fields="draft.extra_fields"
                    :showExtraFields="draftPanelFields"
                  />
                </SlugContentComponent>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </template>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import HeaderComponent from './HeaderComponent.vue';
import SlugContentComponent from './SlugContentComponent.vue';
import ExpandedExtraFieldsComponent from './ExpandedExtraFieldsComponent.vue';
import InfoContentComponent from './InfoContentComponent.vue';
import { mapState } from 'vuex';

export default {
  name: 'CompareVersionsModal',
  props: {
    draft: {
      type: Object,
      default: () => {},
    },
    current: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    HeaderComponent,
    SlugContentComponent,
    ExpandedExtraFieldsComponent,
    InfoContentComponent,
  },
  data: () => ({
    loadingSave: false,
    loadingCurrentSlug: false,
    currentPanelFields: false,
    draftPanelFields: false,
    tab: null,
    headerTabs: ['Atual', 'Editado'],
  }),
  mounted() {
    this.getCurrentSlug(this.current);
  },
  methods: {
    async getCurrentSlug(story) {
      this.loadingCurrentSlug = true;
      await this.$store.dispatch('news/getSlugToEdit', story);
      this.loadingCurrentSlug = false;
    },
    openCurrentPanelFields() {
      this.currentPanelFields = !this.currentPanelFields;
    },
    openDraftPanelFields() {
      this.draftPanelFields = !this.draftPanelFields;
    },
    findExtraFieldInfo(field) {
      return this.fieldMapping.find(item => item.field == field);
    },
  },
  computed: {
    ...mapState({
      fieldMapping: state => state.news.fieldMapping,
      isLoadingEdition: state => state.news.isLoadingEdition,
    }),
    currentFormatted() {
      return {
        ...this.current,
        extra_fields: this.current.extra_fields.map(field => ({
          ...this.findExtraFieldInfo(field.field),
          value: field.value,
        })),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/inputs.scss';

.v-dialog--fullscreen {
  overflow-x: hidden !important;
}

.wrapper-content {
  min-height: calc(100vh - 300px);
}
.warning-message {
  color: #fa5e15;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  line-height: 1.2;
}

.theme--light.v-sheet {
  &.v-card {
    background-color: #eeeeee !important;
    padding: 16px;

    @include for-size(phone-only) {
      background-color: #fff !important;
    }
  }

  .v-card {
    background-color: #fff !important;

    h2 {
      font-size: 18px;
    }

    .v-btn {
      @include for-size(phone-only) {
        width: 44px !important;
        height: 44px !important;
        padding: 0 !important;
        background-color: transparent !important;
        border: thin solid #ee8e51 !important;
      }

      @include for-size(tablet-portrait-up) {
        width: 44px !important;
        height: 44px !important;
        padding: 0 !important;
        background-color: transparent !important;
        border: thin solid #ee8e51 !important;
      }

      @include for-size(tablet-landscape-up) {
        width: 44px !important;
        height: 44px !important;
        padding: 0 !important;
        background-color: transparent !important;
        border: thin solid #ee8e51 !important;
      }

      @include for-size(tablet-landscape-up) {
        padding: 16px 50px !important;
      }

      font-size: 14px;
      font-family: 'globotipo' !important;

      &.v-btn--disabled {
        color: #fff !important;
        opacity: 0.6;
      }
      &.v-btn--outlined {
        border: thin solid #ee8e51;
        color: #ee8e51;
      }
      &.gradient-primary {
        background: linear-gradient(
          146deg,
          #f99a15 17.85%,
          #f98815 37.17%,
          #fa6015 81.19%
        ) !important;
        color: #fff;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
}

.v-tabs {
  ::v-deep .v-slide-group__wrapper {
    .v-slide-group__content,
    .v-tabs-bar__content {
      justify-content: center !important;

      .v-tab {
        flex: 1 !important;
        width: 100%;

        &.v-tab--active {
          border-bottom: 2px solid currentColor;
        }
      }
    }
  }
}
</style>
